// src/services/AuthService.ts
import StorageService from './StorageService';

export class AuthService {
  private static instance: AuthService;

  private constructor() {}

  public static getInstance(): AuthService {
    if (!AuthService.instance) {
      AuthService.instance = new AuthService();
    }
    return AuthService.instance;
  }

  public isAuthenticated = (): boolean => {
    const token = StorageService.getToken();
    return !!token;
  }

  public clearAuth = (): void => {
    StorageService.clearAuth();
  }
}

export const authService = AuthService.getInstance();
